@if (formError) {
  <div class="lin-form-error">{{ formError }}</div>
}
@if (form) {
  <form lin-layout-form [formGroup]="form" (ngSubmit)="saveData()">
    <lin-layout-form-sections-wrapper>
      <lin-layout-form-section [layout]="columnLayout">
        <label class="settings-block">{{ 'SETTINGS.OTP' | translate }}:</label>
        <div formGroupName="roles">
          @for (role of roles; track role.id) {
            <div class="block-item" fxLayout="row">
              <label>{{ role.displayName }}</label>
              <mat-checkbox fxLayout="row" [formControlName]="role.id"></mat-checkbox>
            </div>
          }
        </div>

        @if (hasTermsAgreement) {
          <div class="block-item" fxLayout="row">
            <label>{{ 'TERMS_OF_USE.SETTING_LABEL' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="userTermsAcceptance"></mat-checkbox>
          </div>
        }

        <label class="settings-block notification-transport">{{ 'SETTINGS.NOTIFICATION_TRANSPORT' | translate }}:</label>
        <div formGroupName="notificationsTransport">
          @for (notification of notificationsTransport; track notification.id) {
            <div class="block-item" fxLayout="row">
              <label>{{ notification.displayName }}</label>
              <mat-checkbox fxLayout="row" [formControlName]="notification.id"></mat-checkbox>
            </div>
          }
        </div>
      </lin-layout-form-section>

      @if (!areAdminSettings) {
        <lin-layout-form-section [layout]="columnLayout">
          <label class="settings-block">{{ 'SETTINGS.ADDITIONAL_FEATURES' | translate }}:</label>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.ASSET_ENABLE' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="asset"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.MESSENGER_ENABLE' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="messenger"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.ENABLE_LINK_SHARING' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="trackingLink"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label [class.label-disabled]="disableBilling">{{ 'SETTINGS.BILLING_ENABLE' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="billing" [disabled]="disableBilling"></mat-checkbox>
          </div>
          @if (disableBilling) {
            <span class="deactivated-info">{{ 'SETTINGS.BILLING_DISABLED' | translate }}</span>
          }

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.ALLOW_DRIVER_MOBILE' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="loginWithId"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.ENABLE_SOS_BUTTON_IN_APP' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="enableSOSInApp"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.HIDE_MAP_IN_APP' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="hideMapInApp"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.HIDE_DRIVING_BEHAVIOR_IN_APP' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="hideDrivingBehaviorInApp"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.HIDE_FORMS_ON_THE_DASHBOARDS_IN_MOBILE_APP' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="hideFormsOnTheDashboardsInMobileApp"></mat-checkbox>
          </div>

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.DISALLOW_DRIVERS_LOGIN_IN_WEB_APP' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="disallowDriverLoginWebapp"></mat-checkbox>
          </div>

          @if (plan?.name === PlanName.FleetPlus) {
            <div class="block-item block-item-lg" fxLayout="row">
              <label>{{ 'SETTINGS.ENABLE_NEW_DIGITAL_INSPECTION_FORMS' | translate }}</label>
              <mat-checkbox fxLayout="row" formControlName="enableNewDigitalForms"></mat-checkbox>
            </div>
          }

          <div class="block-item block-item-lg" fxLayout="row">
            <label>{{ 'SETTINGS.AUTOLOGOUT_DRIVERS' | translate }}</label>
            <mat-checkbox fxLayout="row" formControlName="driverAutoLogoutOption"></mat-checkbox>
          </div>

          @if (authService.getCurrentUser().isAdmin()) {
            <div class="block-item block-item-lg" fxLayout="row">
              <label>{{ 'SETTINGS.ENABLE_TRIP_CODES' | translate }}</label>
              <mat-checkbox fxLayout="row" formControlName="tripCode"></mat-checkbox>
            </div>

            <div class="block-item block-item-lg" fxLayout="row">
              <label>{{ 'SETTINGS.CAMERAS_ENABLE' | translate }}</label>
              <mat-checkbox fxLayout="row" formControlName="cameras"></mat-checkbox>
            </div>

            <div class="block-item block-item-lg block-item-lg-icon" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <label
                  >{{ 'SETTINGS.BMA_ENABLE' | translate }}
                  <button
                    mat-icon-button
                    type="button"
                    class="info-icon"
                    [matTooltip]="'SETTINGS.BMA_ENABLE_TOOLTIP' | translate"
                    matTooltipPosition="above"
                    tabindex="-1"
                  >
                    <mat-icon>info</mat-icon>
                  </button>
                </label>
              </div>

              <mat-checkbox formControlName="bma"></mat-checkbox>
            </div>

            <div class="block-item block-item-lg block-item-lg-icon" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <label
                  >{{ 'SETTINGS.ENABLE_BLOCKOUT' | translate }}
                  <button
                    mat-icon-button
                    type="button"
                    class="info-icon"
                    [matTooltip]="'SETTINGS.BLOCKOUT_ENABLE_TOOLTIP' | translate"
                    matTooltipPosition="above"
                    tabindex="-1"
                  >
                    <mat-icon>info</mat-icon>
                  </button>
                </label>
              </div>

              <mat-checkbox formControlName="isBlockout"></mat-checkbox>
            </div>
          }
        </lin-layout-form-section>
      }

      <lin-layout-form-section [layout]="columnLayout">
        <label class="settings-block">{{ 'SETTINGS.BRAND' | translate }}:</label>

        <label>{{ 'SETTINGS.THEME' | translate }}:</label>
        <mat-form-field>
          <mat-select formControlName="theme">
            @for (theme of themes; track theme.id) {
              <mat-option [value]="theme.id">{{ theme.name }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'SETTINGS.TRANSLATION' | translate }}:</label>
        <mat-form-field>
          <mat-select formControlName="translation">
            <mat-option value=""></mat-option>
            @for (language of translationsLanguages; track language.id) {
              <mat-option [value]="language.id">{{ language.displayName }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'SETTINGS.NOTIFICATION_TEMPLATE' | translate }}:</label>
        <mat-form-field>
          <mat-select formControlName="notificationTemplate">
            @for (template of notificationsTemplates; track template.id) {
              <mat-option [value]="template.id">{{ template.name }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (!areAdminSettings) {
          <label>{{ 'SETTINGS.INTEGRATIONS' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="integrations" multiple>
              @for (integration of integrations; track integration.id) {
                <mat-option [value]="integration.id">{{ integration.name }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <label>{{ 'SETTINGS.MAP_PROVIDER' | translate }}:</label>
        <mat-form-field>
          <mat-select formControlName="mapProvider">
            @for (mapProvider of mapProviders; track mapProvider.id) {
              <mat-option [value]="mapProvider.id">{{ mapProvider.displayName }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'SETTINGS.MAP_API_OPTIONS' | translate }}:</label>
        <mat-form-field>
          <mat-select formControlName="mapApiOptions" multiple>
            @for (option of mapApiOptions; track option.id) {
              <mat-option [value]="option.id">{{ option.displayName | translate }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (currentTimezone) {
          <label>{{ 'SETTINGS.TIMEZONE' | translate }}:</label>
          <mat-form-field>
            <lin-form-timezone-select [timezones]="timezones" formControlName="currentTimezone"></lin-form-timezone-select>
            <mat-error>
              <lin-form-field-error></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        @if (!areAdminSettings) {
          <label>{{ 'SETTINGS.REPORTS_OPTIONS' | translate }}:</label>
          <mat-form-field>
            <mat-select [(value)]="selectedReportsOptions" formControlName="reportsOptions" multiple>
              @for (option of reportsOptions; track option.name) {
                <mat-option [value]="option.name">{{ option.displayName | translate }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error></lin-form-field-error>
            </mat-error>
          </mat-form-field>

          <label>{{ 'SETTINGS.BILLABLE_ADDONS' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="billableAddons" multiple>
              @for (addon of billableAddons; track addon.name) {
                <mat-option [value]="addon.name">{{ addon.displayName | translate }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }
      </lin-layout-form-section>
    </lin-layout-form-sections-wrapper>

    <lin-layout-form-toolbar>
      <lin-form-submit-button [isLoading]="isSubmitting" data-testid="btn-save"> {{ 'BUTTONS.SAVE' | translate }} </lin-form-submit-button>
    </lin-layout-form-toolbar>
  </form>
}
